import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const sidebarRecentsFilterSelectedEvent = EVENT_PAYLOAD;
export const orgAdminSidebarInviteButtonClickedEvent = {
    event: 'org admin sidebar invite button clicked',
    data: {},
};
export const sidebarMenuItemClickedEvent = EVENT_PAYLOAD;
export const signOutSelectedEvent = EVENT_PAYLOAD;
export const sidebarAccountMenuOpenedEvent = EVENT_PAYLOAD;
export const sidebarSubmenuLinkClickedEvent = EVENT_PAYLOAD;
export const sessionActionsMenuOpenedEvent = EVENT_PAYLOAD;
// Fired when the user toggles the pinned Spaces "Show more" / "Show less"
// preview in the sidebar. `surface` distinguishes the web sidebar from the
// Windows/xplat sidebar; `pinnedCount` is the total number of pinned Spaces.
export const sidebarPinnedSpacesShowMoreClickedEvent = EVENT_PAYLOAD;
export const sidebarToggledEvent = EVENT_PAYLOAD;
// Fired when a page without an app header opens the mobile sidebar drawer from
// its own menu button. `source` names that page.
export const mobileSidebarOpenedEvent = EVENT_PAYLOAD;
export const historyNavigationSelectedEvent = EVENT_PAYLOAD;
export const sidebarSpaceSelectedEvent = EVENT_PAYLOAD;
export const sidebarSpaceUnpinnedEvent = EVENT_PAYLOAD;
export const sidebarSpaceThreadsToggledEvent = EVENT_PAYLOAD;
export const sidebarProjectActionsMenuOpenedEvent = EVENT_PAYLOAD;
export const sidebarProjectActionsMenuItemSelectedEvent = EVENT_PAYLOAD;
export const sidebarProjectListControlSelectedEvent = EVENT_PAYLOAD;
export const sidebarProjectsToggledEvent = EVENT_PAYLOAD;
export const sidebarProjectsHeaderActionSelectedEvent = EVENT_PAYLOAD;
export const sidebarSessionSelectedEvent = EVENT_PAYLOAD;
export const sidebarSectionToggledEvent = EVENT_PAYLOAD;
export const sidebarCreateSpaceSelectedEvent = EVENT_PAYLOAD;
export const INCOGNITO_TOGGLED_EVENT_NAME = 'incognito toggled';
export const incognitoToggledEvent = EVENT_PAYLOAD;
export const sidebarSectionHeadingSelectedEvent = EVENT_PAYLOAD;
export const settingsSectionSelectedEvent = EVENT_PAYLOAD;
export const newSessionSelectedEvent = EVENT_PAYLOAD;
export const sessionSearchOpenedEvent = EVENT_PAYLOAD;
export const sidebarProjectRetrySelectedEvent = EVENT_PAYLOAD;
export const sidebarSessionRetrySelectedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map